import { ADD_RESOLVE, CLEAR_RESOLVE } from './kaiziqResolveTypes';

const initialState = {
    currentResolve: null,
    loading: false
};

export default function kaiziqResolveReducer(state = initialState, action) {
    switch (action.type) {
        case ADD_RESOLVE:
            return { ...state, currentResolve: action.payload };
        case CLEAR_RESOLVE:
            return initialState;
        default:
            return state;
    }
}
